import { clone } from '@jack-henry/frontend-utils/functions';
import { UserTimeAccessDayDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { DayOfWeek, TimeAccessType } from './time-access.entity';

const nullCompanyUserTimeAccessDay: UserTimeAccessDayDto = {
    timeAccessType: 0, // undefined
    dayOfWeek: 0, // Sunday
    beginTime: '',
    endTime: '',
};

export class UserTimeAccessDay extends DomainEntity<UserTimeAccessDayDto> {
    constructor(dto = clone(nullCompanyUserTimeAccessDay)) {
        super(dto);
    }

    public createDefault(): this {
        return new UserTimeAccessDay(clone(nullCompanyUserTimeAccessDay)) as this;
    }

    public get timeAccessType() {
        return this.dto.timeAccessType as unknown as TimeAccessType;
    }

    public set timeAccessType(value: TimeAccessType) {
        this.dto.timeAccessType = value as number;
    }

    public get dayOfWeek() {
        return this.dto.dayOfWeek as unknown as DayOfWeek;
    }

    public get dayOfWeekName() {
        const dayOfWeekKey = Object.keys(DayOfWeek).find(
            key => DayOfWeek[key as keyof typeof DayOfWeek] === this.dayOfWeek
        );
        return dayOfWeekKey ?? 'Unknown';
    }

    public normalizeTimeForVaadinPicker(time?: string) {
        // Strip seconds for Vaadin time picker compatibility. (converts "17:00:00" to "17:00")
        // Enables deepEquals check to work. See isPristine() in fi-user-profile.component.ts for context.
        // Only strip when format is HH:MM:SS (three colon-separated parts)
        return time?.replace(/^(\d{1,2}:\d{2}):\d{2}$/, '$1') ?? '';
    }

    public get beginTime() {
        if (!this.dto.beginTime) {
            return '';
        }
        return this.normalizeTimeForVaadinPicker(this.dto.beginTime);
    }

    public set beginTime(value: string) {
        this.dto.beginTime = this.normalizeTimeForVaadinPicker(value);
    }

    public get endTime() {
        if (!this.dto.endTime) {
            return '';
        }
        return this.normalizeTimeForVaadinPicker(this.dto.endTime);
    }

    public set endTime(value: string) {
        this.dto.endTime = this.normalizeTimeForVaadinPicker(value);
    }
}
